<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.only('user_id', 'vat_number', 'title')"
      :model="model"
      :errors="errors"
      layout="vertical" />

    <div class="form-group">
      <label>Published at</label>
      <datetime
        v-model="model.published_at"
        type="datetime"
        input-class="form-control"/>
    </div>

    <div class="form-group">
      <label>Moderated at</label>
      <datetime
        v-model="model.moderated_at"
        type="datetime"
        input-class="form-control"
        value-zone=""/>
    </div>


    <div class="form-group">
      <div class="row">
        <div class="col-md-2"/>
        <div class="col-md-6">
          <field
            :field="fields.get('location')"
            :model="model"
            :errors="errors"
          />
          <div class="row">
            <div class="col-md-4"/>
            <div class="col-md-8">
              <field
                :field="fields.get('location_radius')"
                :model="model"
                :errors="errors"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <fields
      :fields="fields.except('published_at', 'moderated_at', 'user_id', 'vat_number', 'title', 'location', 'location_radius')"
      :model="model"
      :errors="errors"
      layout="vertical" />
    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        {{ buttonText || 'Save' }}
      </b-button>
      <b-button
        type="button"
        variant="light"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import Proxy from './Proxy';

export default {
  name: 'CompaniesForm',

  mixins: [ResourceFormMixin],

  data() {
    return {
      buttonText: null,
    }
  },

  watch: {
    'model.status'(newStatus) {
      this.$emit('status:changed', newStatus);
    },

    'model.services_id'(services) {
      if (this.buttonText !== null && services && services.length) return

      if (!this.id || (!!this.id && services && services.length)) {
        this.buttonText = 'Save'
      } else {
        this.buttonText = 'Publish'
      }
    }
  },

  created() {

    //map behaviour fix
    let apiKey = process.env.VUE_APP_GOOGLE_MAP_KEY
    let libs = ['places']

    let scriptSrc = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`

    if (libs && libs.length)
      scriptSrc = `${scriptSrc}&libraries=${libs.join()}`

    // create script with src and insert it
    const scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', scriptSrc)
    document.head.appendChild(scriptEl)

    this.loadForm(Proxy);
  },

  methods: {
    submit() {
      this.save(Proxy)
        .then(() => {
          if (this.updating) {
            this.$toast.success(this.$t('Company was saved successfully'));
          } else {
            this.$toast.success(this.$t('Company was created, you can now add services and offers'));
          }
        });
    },
  },
};
</script>
